import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SEO from '../../components/common/SEO';
import { useVendorAuth } from '../../context/VendorAuthContext';
import { useNavigate } from 'react-router-dom';
import './Kyc.css';
import { generateCompanyDescription } from '../custom/geminiService';
import ImageCropperModal from '../../components/common/ImageCropperModal';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';

const KYC_ICONS = {
    accountInfo: <svg viewBox="0 0 24 24"><path fill="currentColor" d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z" /></svg>,
    business: <svg viewBox="0 0 24 24"><path fill="currentColor" d="M22 7h-6V5a3 3 0 0 0-3-3h-2a3 3 0 0 0-3 3v2H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2ZM10 5a1 1 0 0 1 1-1h2 a1 1 0 0 1 1 1v2h-4V5Z" /></svg>,
    personal: <svg viewBox="0 0 24 24"><path fill="currentColor" d="M12 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm0 2c-4.42 0-8 3.58-8 8v1h16v-1c0-4.42-3.58-8-8-8Z" /></svg>,
    address: <svg viewBox="0 0 24 24"><path fill="currentColor" d="M12 2a8 8 0 0 0-8 8c0 5.25 8 12 8 12s8-6.75 8-12a8 8 0 0 0-8-8Zm0 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z" /></svg>,
    media: <svg viewBox="0 0 24 24"><path fill="currentColor" d="M21 19V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2ZM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5Z" /></svg>,
    info: <svg viewBox="0 0 24 24"><path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" /></svg>,
    categories: <svg viewBox="0 0 24 24"><path fill="currentColor" d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z" /></svg>,
    whatsapp: <svg viewBox="0 0 24 24"><path fill="currentColor" d="M12.012 2c-5.506 0-9.989 4.478-9.99 9.984a9.964 9.964 0 0 0 1.333 4.996L2 22l5.135-1.348a9.96 9.96 0 0 0 4.877 1.28c5.508 0 9.99-4.478 9.99-9.986 0-2.67-1.037-5.18-2.92-7.062A9.925 9.925 0 0 0 12.012 2zm4.957 14.158c-.273.767-1.562 1.39-2.146 1.475-.523.076-1.21.1-3.488-.846-2.909-1.21-4.793-4.177-4.937-4.37-.146-.19-1.182-1.576-1.182-3.007 0-1.43.747-2.13.103-2.428-.31-.143-.68-.236-1.07-.236-.379 0-.996.143-1.42.6-.436.47-1.66 1.62-1.66 3.947 0 2.33 1.69 4.58 1.928 4.9 0 .07 3.328 5.085 8.06 7.126.837.362 1.493.578 2.003.74.84.267 1.61.229 2.215.14.675-.1 2.072-.846 2.363-1.66.29-.816.29-1.512.203-1.66-.086-.143-.326-.236-.68-.423z" /></svg>,
    email: <svg viewBox="0 0 24 24"><path fill="currentColor" d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" /></svg>,
    social: <svg viewBox="0 0 24 24"><path fill="currentColor" d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11A2.99 2.99 0 1 0 15 5c0 .24.04.47.09.7L8.04 9.81A3 3 0 1 0 8.04 14.2l7.12 4.16c-.04.2-.07.41-.07.64a2.91 2.91 0 1 0 2.91-2.92Z" /></svg>,
    about: <svg viewBox="0 0 24 24"><path fill="currentColor" d="M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Zm2 4v2h12V8H6Zm0 4v2h12v-2H6Zm0 4v2h8v-2H6Z" /></svg>,
    greenTick: <svg viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" /></svg>
};

const CATEGORIES_LIST = ["Holidays", "Hotels", "Cabs", "Tirth Yatra", "Medical Tourism", "Other"];
const SOCIAL_MEDIA_FIELDS = [
    ['instagram', 'Instagram', 'bi-instagram'], ['facebook', 'Facebook', 'bi-facebook'],
    ['linkedin', 'LinkedIn', 'bi-linkedin'], ['twitter', 'X / Twitter', 'bi-twitter-x'],
    ['youtube', 'YouTube', 'bi-youtube'], ['pinterest', 'Pinterest', 'bi-pinterest']
];
const EMPTY_SOCIAL_LINKS = Object.fromEntries(SOCIAL_MEDIA_FIELDS.map(([key]) => [key, '']));

const Kyc = ({ filterTabs, isKYC = false, startFromBeginning = false }) => {
    const { vendor, updateVendor } = useVendorAuth();
    const navigate = useNavigate();

    // Determine registrationStep & Mode
    const registrationStep = Number(vendor?.last_registration_step ?? 0);
    const isWizardMode = registrationStep < 12;

    // New Linear Tab List
    const tabList = [
        { id: 3, key: 'business', label: 'Business Verification', icon: KYC_ICONS.business },
        { id: 4, key: 'personal', label: 'Personal KYC', icon: KYC_ICONS.personal },
        { id: 5, key: 'address', label: 'Operational Address', icon: KYC_ICONS.address },
        { id: 6, key: 'accountInfo', label: 'Account Info', icon: KYC_ICONS.accountInfo },
        { id: 7, key: 'media', label: 'Logo and Banner', icon: KYC_ICONS.media },
        { id: 8, key: 'categories', label: 'Categories', icon: KYC_ICONS.categories },
        { id: 9, key: 'info', label: 'Company Info', icon: KYC_ICONS.info },
        { id: 10, key: 'whatsapp', label: 'WhatsApp Numbers', icon: KYC_ICONS.whatsapp },
        { id: 11, key: 'email', label: 'Email IDs', icon: KYC_ICONS.email },
        { id: 12, key: 'social', label: 'Social Links', icon: KYC_ICONS.social },
        { id: 13, key: 'about', label: 'About Company', icon: KYC_ICONS.about }
    ];

    // Filter tabs based on prop
    const displayedTabs = filterTabs ? tabList.filter(t => filterTabs.includes(t.key)) : tabList;

    // Track activeTab state (start at first incomplete step if wizard mode)
    const getInitialActiveTab = () => {
        if (!isWizardMode) return displayedTabs[0]?.id ?? 3;
        const firstIncomplete = displayedTabs.find(t => t.id >= registrationStep) || displayedTabs[0];
        return firstIncomplete.id;
    };

    const initialActiveTab = getInitialActiveTab();
    const [activeTab, setActiveTab] = useState(initialActiveTab);

    const [isLoading, setIsLoading] = useState(false);
    const [isGeneratingAbout, setIsGeneratingAbout] = useState(false);
    const [notification, setNotification] = useState({ message: '', type: '' });

    // --- FORM DATA STATE ---
    const [formData, setFormData] = useState({
        // Account Info
        email: '',
        password: '',
        confirmPassword: '',

        // Business
        gst_number: '',
        company_name: '',

        // Personal
        aadhaar_mobile: '',
        personal_name: '',
        personal_dob: '',
        personal_gender: '',
        personal_aadhaar: '',

        // Address
        company_address: '',
        company_landmark: '',
        company_city: '',
        company_state: '',
        company_pincode: '',
        operational_address: '',
        operational_landmark: '',
        operational_city: '',
        operational_state: '',
        operational_pincode: '',

        // Info
        phone: '',
        whatsapp_no: '',
        about_company: '',
        social_media_links: { ...EMPTY_SOCIAL_LINKS },

        // Notification contacts (dynamic lists up to 3 elements)
        notification_emails: [],
        notification_whatsapps: [],

        // Categories
        business_categories: [],
        other_category: ''
    });

    // Address choice radio
    const [addressOption, setAddressOption] = useState('new');

    // Files state
    const [selectedFiles, setSelectedFiles] = useState({
        personalDocFile: null,
        companyLogo: null,
        companyBanner: null
    });

    // File Preview URLs
    const [filePreviews, setFilePreviews] = useState({
        personalDoc: '',
        companyLogo: '',
        companyBanner: ''
    });

    // GST verification Cache
    const [gstDataBoxVisible, setGstDataBoxVisible] = useState(false);
    const [gstDetails, setGstDetails] = useState(null);

    // DigiLocker verification Cache
    const [digilockerBoxVisible, setDigilockerBoxVisible] = useState(false);

    // Edit mode states for saved KYC data
    const [isEditingBusiness, setIsEditingBusiness] = useState(false);
    const [isEditingPersonal, setIsEditingPersonal] = useState(false);

    // Populate data from vendor
    useEffect(() => {
        if (vendor) {
            let parsedCategories = [];
            if (vendor.business_categories) {
                try {
                    parsedCategories = typeof vendor.business_categories === 'string' ? JSON.parse(vendor.business_categories) : vendor.business_categories;
                } catch (e) {
                    parsedCategories = [];
                }
            }

            let parsedEmails = [];
            if (vendor.notification_emails) {
                try {
                    parsedEmails = typeof vendor.notification_emails === 'string' ? JSON.parse(vendor.notification_emails) : vendor.notification_emails;
                } catch (e) {
                    parsedEmails = [vendor.email];
                }
            } else {
                parsedEmails = vendor.email ? [vendor.email] : [];
            }
            if (!Array.isArray(parsedEmails)) {
                parsedEmails = [vendor.email];
            }

            let parsedWhatsapps = [];
            if (vendor.notification_whatsapps) {
                try {
                    parsedWhatsapps = typeof vendor.notification_whatsapps === 'string' ? JSON.parse(vendor.notification_whatsapps) : vendor.notification_whatsapps;
                } catch (e) {
                    parsedWhatsapps = [vendor.phone];
                }
            } else {
                parsedWhatsapps = vendor.whatsapp_no ? [vendor.whatsapp_no] : (vendor.phone ? [vendor.phone] : []);
            }
            if (!Array.isArray(parsedWhatsapps)) {
                parsedWhatsapps = vendor.whatsapp_no ? [vendor.whatsapp_no] : (vendor.phone ? [vendor.phone] : []);
            }

            if (parsedEmails.length === 0 && vendor.email) parsedEmails.push(vendor.email);
            if (parsedWhatsapps.length === 0 && (vendor.whatsapp_no || vendor.phone)) parsedWhatsapps.push(vendor.whatsapp_no || vendor.phone);

            let parsedSocialLinks = {};
            if (vendor.social_media_links) {
                try {
                    parsedSocialLinks = typeof vendor.social_media_links === 'string'
                        ? JSON.parse(vendor.social_media_links)
                        : vendor.social_media_links;
                } catch (e) {
                    parsedSocialLinks = {};
                }
            }

            setFormData(prev => ({
                ...prev,
                name: vendor.name || '',
                email: vendor.email || '',
                personal_name: vendor.personal_name || '',
                personal_dob: vendor.personal_dob || '',
                personal_gender: vendor.personal_gender || '',
                personal_aadhaar: vendor.personal_aadhaar || '',
                gst_number: vendor.gst_number || '',
                company_name: vendor.company_name || '',
                company_address: vendor.company_address || '',
                company_landmark: vendor.company_landmark || '',
                company_city: vendor.company_city || '',
                company_state: vendor.company_state || '',
                company_pincode: vendor.company_pincode || '',
                operational_address: vendor.operational_address || '',
                operational_landmark: vendor.operational_landmark || '',
                operational_city: vendor.operational_city || '',
                operational_state: vendor.operational_state || '',
                operational_pincode: vendor.operational_pincode || '',
                phone: vendor.phone || '',
                whatsapp_no: vendor.whatsapp_no || vendor.phone || '',
                about_company: vendor.about_company || '',
                social_media_links: { ...EMPTY_SOCIAL_LINKS, ...parsedSocialLinks },
                notification_emails: parsedEmails,
                notification_whatsapps: parsedWhatsapps,
                business_categories: parsedCategories || [],
                other_category: vendor.other_category || ''
            }));

            // Prefill file preview URLs from backend paths
            setFilePreviews({
                personalDoc: vendor.personal_doc_file_path || '',
                companyLogo: vendor.company_logo_path || '',
                companyBanner: vendor.company_banner_path || ''
            });

            // Address option switch pre-population
            if (
                vendor.operational_address &&
                vendor.operational_address === vendor.company_address &&
                vendor.operational_city === vendor.company_city &&
                vendor.operational_state === vendor.company_state &&
                vendor.operational_pincode === vendor.company_pincode
            ) {
                setAddressOption('same');
            } else {
                setAddressOption('new');
            }
            if (vendor.personal_aadhaar) {
                setDigilockerBoxVisible(true);
            }
        }
    }, [vendor]);

    // Handle timer for notifications
    useEffect(() => {
        if (notification.message) {
            const timer = setTimeout(() => {
                setNotification({ message: '', type: '' });
            }, 4000);
            return () => clearTimeout(timer);
        }
    }, [notification]);

    // Handle text input changes
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleGenerateAboutCompany = async () => {
        const companyName = formData.company_name.trim();
        if (!companyName) {
            setNotification({ message: 'Please add and save your Company Name before generating a description.', type: 'danger' });
            return;
        }

        const location = [
            formData.operational_city || formData.company_city,
            formData.operational_state || formData.company_state
        ].filter(Boolean).join(', ');

        setNotification({ message: '', type: '' });
        setIsGeneratingAbout(true);
        try {
            const description = await generateCompanyDescription(
                companyName,
                formData.business_categories,
                location
            );
            setFormData(prev => ({ ...prev, about_company: description.trim() }));
            setNotification({ message: 'Company description generated. Review it, then click Save Changes.', type: 'success' });
        } catch (error) {
            setNotification({ message: error.message || 'Failed to generate the company description.', type: 'danger' });
        } finally {
            setIsGeneratingAbout(false);
        }
    };

    // Image Cropper Modal State
    const [cropModal, setCropModal] = useState({
        show: false,
        src: null,
        type: null,
        aspectRatio: 1,
        circularCrop: false,
        originalFile: null
    });

    // Handle File inputs
    const handleFileChange = (e) => {
        const { name, files } = e.target;
        const file = files[0];
        if (file) {
            if (name === 'companyLogo' || name === 'companyBanner') {
                const reader = new FileReader();
                reader.onload = () => {
                    setCropModal({
                        show: true,
                        src: reader.result,
                        type: name,
                        aspectRatio: name === 'companyLogo' ? 1 : 16 / 9,
                        circularCrop: name === 'companyLogo',
                        originalFile: file
                    });
                };
                reader.readAsDataURL(file);
                e.target.value = null;
            } else {
                setSelectedFiles(prev => ({
                    ...prev,
                    [name]: file
                }));
                const previewUrl = URL.createObjectURL(file);
                setFilePreviews(prev => ({
                    ...prev,
                    [name]: previewUrl
                }));
            }
        }
    };

    const handleCropSave = (blob) => {
        const { type, originalFile } = cropModal;
        const croppedFile = new File([blob], originalFile.name, { type: 'image/jpeg' });
        const previewUrl = URL.createObjectURL(croppedFile);

        setSelectedFiles(prev => ({ ...prev, [type]: croppedFile }));
        setFilePreviews(prev => ({ ...prev, [type]: previewUrl }));
        
        setCropModal({ show: false, src: null, type: null, aspectRatio: 1, circularCrop: false, originalFile: null });
    };

    // Handle Category checklist checkbox changes
    const handleCategoryCheckboxChange = (e) => {
        const { value, checked } = e.target;
        setFormData(prev => {
            let updatedList = [...prev.business_categories];
            if (checked) {
                if (!updatedList.includes(value)) updatedList.push(value);
            } else {
                updatedList = updatedList.filter(cat => cat !== value);
            }
            return {
                ...prev,
                business_categories: updatedList
            };
        });
    };

    const handleNotificationEmailChange = (index, value) => {
        setFormData(prev => {
            const newList = [...prev.notification_emails];
            newList[index] = value;
            return { ...prev, notification_emails: newList };
        });
    };

    const addNotificationEmailField = () => {
        setFormData(prev => {
            if (prev.notification_emails.length >= 3) return prev;
            return { ...prev, notification_emails: [...prev.notification_emails, ''] };
        });
    };

    const removeNotificationEmailField = (index) => {
        setFormData(prev => {
            if (prev.notification_emails.length <= 1) return prev;
            const newList = prev.notification_emails.filter((_, idx) => idx !== index);
            return { ...prev, notification_emails: newList };
        });
    };

    const handleNotificationWhatsappChange = (index, value) => {
        setFormData(prev => {
            const newList = [...prev.notification_whatsapps];
            newList[index] = value;
            return { ...prev, notification_whatsapps: newList };
        });
    };

    const addNotificationWhatsappField = () => {
        setFormData(prev => {
            if (prev.notification_whatsapps.length >= 3) return prev;
            return { ...prev, notification_whatsapps: [...prev.notification_whatsapps, ''] };
        });
    };

    const removeNotificationWhatsappField = (index) => {
        setFormData(prev => {
            if (prev.notification_whatsapps.length <= 1) return prev;
            const newList = prev.notification_whatsapps.filter((_, idx) => idx !== index);
            return { ...prev, notification_whatsapps: newList };
        });
    };

    // Toggle same / new Operational address option
    const handleAddressOptionChange = (option) => {
        setAddressOption(option);
        if (option === 'same') {
            setFormData(prev => ({
                ...prev,
                operational_address: prev.company_address,
                operational_landmark: prev.company_landmark,
                operational_city: prev.company_city,
                operational_state: prev.company_state,
                operational_pincode: prev.company_pincode
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                operational_address: '',
                operational_landmark: '',
                operational_city: '',
                operational_state: '',
                operational_pincode: ''
            }));
        }
    };

    // Fetch GST details from backend proxy
    const handleFetchGstDetails = async () => {
        if (!formData.gst_number || !/^[0-9A-Z]{15}$/i.test(formData.gst_number.trim())) {
            setNotification({ message: 'Please enter a valid 15-digit GST Number.', type: 'danger' });
            return;
        }
        setIsLoading(true);
        setNotification({ message: '', type: '' });

        try {
            const token = localStorage.getItem('authToken');
            const gstinToVerify = formData.gst_number.toUpperCase();
            const emailForGST = formData.email || vendor.email || 'info@mangoloops.com';

            const response = await axios.post(`${API_BASE_URL}/vendors/verify-gstin`, {
                gstin: gstinToVerify,
                userEmail: emailForGST
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });

            if (response.data && response.data.success && response.data.data) {
                const details = response.data.data;
                const fetchedCompanyName = details.lgnm || details.tradeNm || '';
                let address = '', city = '', state = '', pincode = '';

                if (details.pradr && details.pradr.addr) {
                    address = [details.pradr.addr.bnm, details.pradr.addr.st].filter(Boolean).join(', ');
                    city = details.pradr.addr.dst || details.pradr.addr.stcd || '';
                    state = details.pradr.addr.stcd || '';
                    pincode = details.pradr.addr.pncd || '';
                }

                setGstDetails({
                    compName: fetchedCompanyName,
                    gstNo: gstinToVerify,
                    address, city, state, pin: pincode
                });
                setGstDataBoxVisible(true);
                setNotification({ message: 'GST details fetched successfully!', type: 'success' });
            } else {
                setNotification({ message:"GST Number is invalid! Please enter a valid GST Number" ||  response.data.message || 'Verification failed.', type: 'danger' });
            }
        } catch (error) {
            console.error("GST verification error:", error);
            setNotification({ message: error.response?.data?.message || 'Error communicating with GST service.', type: 'danger' });
        } finally {
            setIsLoading(false);
        }
    };

    // Skip GST step
    const handleSkipGst = async () => {
        setIsLoading(true);
        try {
            const token = localStorage.getItem('authToken');
            const response = await axios.post(`${API_BASE_URL}/vendors/update-details`, {
                userId: vendor.id,
                gst_number: 'N/A',
                last_registration_step: isWizardMode ? Math.max(registrationStep, 4) : registrationStep
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (response.data && response.data.user) {
                updateVendor(response.data.user);
                setNotification({ message: 'GST skipped. Moving to Personal KYC.', type: 'success' });
                setGstDataBoxVisible(false);
                if (isWizardMode) {
                    setActiveTab(4);
                }
            }
        } catch (error) {
            setNotification({ message: 'Failed to update step.', type: 'danger' });
        } finally {
            setIsLoading(false);
        }
    };

    // Confirm GST pre-fill details and submit
    const handleConfirmGst = async () => {
        if (!gstDetails) return;
        setIsLoading(true);
        try {
            const token = localStorage.getItem('authToken');
            const dataToSubmit = {
                userId: vendor.id,
                gst_number: gstDetails.gstNo,
                company_name: gstDetails.compName,
                company_address: gstDetails.address,
                company_city: gstDetails.city,
                company_state: gstDetails.state,
                company_pincode: gstDetails.pin,
                last_registration_step: isWizardMode ? Math.max(registrationStep, 4) : registrationStep
            };

            const response = await axios.post(`${API_BASE_URL}/vendors/update-details`, dataToSubmit, {
                headers: { Authorization: `Bearer ${token}` }
            });

            if (response.data && response.data.user) {
                updateVendor(response.data.user);
                // Pre-fill Operational Address as same by default
                setFormData(prev => ({
                    ...prev,
                    gst_number: gstDetails.gstNo,
                    company_name: gstDetails.compName,
                    company_address: gstDetails.address,
                    company_city: gstDetails.city,
                    company_state: gstDetails.state,
                    company_pincode: gstDetails.pin,
                    operational_address: gstDetails.address,
                    operational_city: gstDetails.city,
                    operational_state: gstDetails.state,
                    operational_pincode: gstDetails.pin
                }));
                setAddressOption('same');
                setGstDataBoxVisible(false);
                setNotification({ message: 'Business verification saved successfully!', type: 'success' });
                if (isWizardMode) {
                    setActiveTab(4);
                }
            }
        } catch (error) {
            setNotification({ message: 'Failed to save business details.', type: 'danger' });
        } finally {
            setIsLoading(false);
        }
    };

    // DigiLocker Dynamic Verification
    const handleDigilockerVerify = async () => {
        setIsLoading(true);
        setNotification({ message: 'Initiating DigiLocker...', type: 'info' });

        try {
            const token = localStorage.getItem('authToken');
            const response = await axios.post(`${API_BASE_URL}/vendors/digilocker/initiate`, {}, {
                headers: { Authorization: `Bearer ${token}` }
            });

            if (response.data && response.data.success && response.data.data.data.authorization_url) {
                const authUrl = response.data.data.data.authorization_url;
                console.log(authUrl, 'authUrl');

                const width = 600;
                const height = 700;
                const left = (window.innerWidth / 2) - (width / 2);
                const top = (window.innerHeight / 2) - (height / 2);

                window.open(authUrl, 'DigiLocker', `width=${width},height=${height},top=${top},left=${left}`);

                const handleMessage = (event) => {
                    console.log(event, 'Digilocker event');

                    if (event.data && event.data.type === 'DIGILOCKER_SUCCESS') {
                        const data = event.data.data;
                        console.log(data, 'Digilocker data');

                        setFormData(prev => ({
                            ...prev,
                            personal_name: data.personal_name || '',
                            personal_dob: data.personal_dob || '',
                            personal_gender: data.personal_gender || '',
                            personal_aadhaar: data.personal_aadhaar || ''
                        }));
                        setDigilockerBoxVisible(true);
                        setNotification({ message: 'Profile details fetched from DigiLocker!', type: 'success' });
                        window.removeEventListener('message', handleMessage);
                    } else if (event.data && event.data.type === 'DIGILOCKER_ERROR') {
                        setNotification({ message: event.data.error || 'DigiLocker verification failed.', type: 'danger' });
                        window.removeEventListener('message', handleMessage);
                    }
                };

                window.addEventListener('message', handleMessage);
            } else {
                setNotification({ message: 'Failed to initiate DigiLocker session.', type: 'danger' });
            }
        } catch (error) {
            console.error('DigiLocker initiate error:', error);
            setNotification({ message: error.response?.data?.message || 'Error communicating with DigiLocker service.', type: 'danger' });
        } finally {
            setIsLoading(false);
        }
    };

    // Tab Submit Router (Wizard Mode vs Settings Mode saving)
    const handleSaveTabDetails = async (tabId) => {
        setNotification({ message: '', type: '' });
        setIsLoading(true);

        const token = localStorage.getItem('authToken');
        const dataToSend = new FormData();

        // Step number tracking for wizard flow
        const targetStep = tabId + 1; // Tab 3 (Business) completed -> Step 4. Tab 5 (Address) completed -> Step 6.

        try {
            if (tabId === 6) { // Account Info
                if (isWizardMode) {
                    if (!formData.email) throw new Error("Email address is required.");
                    if (!formData.password) throw new Error("Password is required.");
                    if (formData.password.length < 6) throw new Error("Password must be at least 6 characters.");
                    if (formData.password !== formData.confirmPassword) throw new Error("Passwords do not match.");

                    // Check email uniqueness
                    const checkEmailResponse = await axios.get(`${API_BASE_URL}/vendors/check-email?email=${encodeURIComponent(formData.email)}&excludeUserId=${vendor.id}`);
                    if (checkEmailResponse.data.exists) {
                        throw new Error("This email address is already registered. Please use another.");
                    }

                    dataToSend.append('name', formData.name.trim());
                    dataToSend.append('email', formData.email.trim());
                    dataToSend.append('password', formData.password);
                } else {
                    // In Settings Mode, we only allow email updates. Password change is a separate page.
                    if (!formData.email) throw new Error("Email cannot be empty.");
                    const checkEmailResponse = await axios.get(`${API_BASE_URL}/vendors/check-email?email=${encodeURIComponent(formData.email)}&excludeUserId=${vendor.id}`);
                    if (checkEmailResponse.data.exists) {
                        throw new Error("This email address is already in use by another account.");
                    }
                    dataToSend.append('name', formData.name.trim());
                    dataToSend.append('email', formData.email.trim());
                }
            }
            else if (tabId === 3) { // Business Verification
                if (isWizardMode) {
                    throw new Error("Please use the 'Fetch GST Details' or 'Skip' action above to proceed.");
                } else {
                    if (!formData.gst_number) throw new Error("GST number is required.");
                    dataToSend.append('gst_number', formData.gst_number);
                    dataToSend.append('company_name', formData.company_name);
                }
            }
            else if (tabId === 4) { // Personal KYC
                if (isWizardMode && !digilockerBoxVisible) {
                    throw new Error("Please verify your Aadhaar via DigiLocker first.");
                }
                if (formData.personal_name) dataToSend.append('personal_name', formData.personal_name);
                if (formData.personal_dob) dataToSend.append('personal_dob', formData.personal_dob);
                if (formData.personal_gender) dataToSend.append('personal_gender', formData.personal_gender);
                if (formData.personal_aadhaar) dataToSend.append('personal_aadhaar', formData.personal_aadhaar);

                if (selectedFiles.personalDocFile) {
                    dataToSend.append('personalDocFile', selectedFiles.personalDocFile);
                }
            }
            else if (tabId === 5) { // Operational Address
                if (!formData.operational_address || !formData.operational_city || !formData.operational_state || !formData.operational_pincode) {
                    throw new Error("Please complete all operational address fields.");
                }
                dataToSend.append('operational_address', formData.operational_address);
                dataToSend.append('operational_landmark', formData.operational_landmark);
                dataToSend.append('operational_city', formData.operational_city);
                dataToSend.append('operational_state', formData.operational_state);
                dataToSend.append('operational_pincode', formData.operational_pincode);
            }
            else if (tabId === 7) { // Logo & Banner
                if (isWizardMode && !selectedFiles.companyLogo && !filePreviews.companyLogo) {
                    throw new Error("Please upload a Company Logo to continue.");
                }
                if (selectedFiles.companyLogo) {
                    dataToSend.append('companyLogo', selectedFiles.companyLogo);
                }
                if (selectedFiles.companyBanner) {
                    dataToSend.append('companyBanner', selectedFiles.companyBanner);
                }
            }
            else if (tabId === 9) { // Company Info
                if (!formData.company_name || !formData.company_name.trim()) {
                    throw new Error("Company Name is required.");
                }
                dataToSend.append('company_name', formData.company_name.trim());
                dataToSend.append('whatsapp_no', formData.whatsapp_no);
            }
            else if (tabId === 8) { // Categories
                if (formData.business_categories.length === 0) {
                    throw new Error("Please select at least one business category.");
                }
                if (formData.business_categories.includes('Other') && !formData.other_category.trim()) {
                    throw new Error("Please specify the 'Other' category service name.");
                }
                dataToSend.append('business_categories', JSON.stringify(formData.business_categories));
                dataToSend.append('other_category', formData.other_category);
            }
            else if (tabId === 10) { // WhatsApp numbers
                const filledWhatsapps = formData.notification_whatsapps.filter(x => x && x.trim() !== '');
                if (filledWhatsapps.length === 0) {
                    throw new Error("At least one WhatsApp number is required.");
                }

                // Uniqueness validation: all numbers must be different
                const normalizedWhatsapps = filledWhatsapps.map(n => {
                    let numStr = String(n).trim().replace(/^\+/, '');
                    if (numStr.length >= 12 && numStr.startsWith('91')) {
                        return numStr.substring(2);
                    }
                    return numStr;
                });
                const uniqueWhatsapps = new Set(normalizedWhatsapps);
                if (uniqueWhatsapps.size !== normalizedWhatsapps.length) {
                    throw new Error("All WhatsApp numbers must be unique. Please remove duplicate numbers.");
                }
                dataToSend.append('notification_whatsapps', JSON.stringify(filledWhatsapps));
            }
            else if (tabId === 11) { // Email IDs
                const filledEmails = formData.notification_emails.filter(x => x.trim() !== '');
                if (filledEmails.length === 0) {
                    throw new Error("At least one Email ID is required.");
                }
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                for (const email of filledEmails) {
                    if (!emailRegex.test(email.trim())) {
                        throw new Error(`Invalid Email address: ${email}`);
                    }
                }
                // Uniqueness validation: all emails must be different
                const normalizedEmails = filledEmails.map(e => e.trim().toLowerCase());
                const uniqueEmails = new Set(normalizedEmails);
                if (uniqueEmails.size !== normalizedEmails.length) {
                    throw new Error("All Email addresses must be unique. Please remove duplicate emails.");
                }
                dataToSend.append('notification_emails', JSON.stringify(filledEmails));
            }
            else if (tabId === 12) { // Social links
                const normalizedLinks = {};
                for (const [key, label] of SOCIAL_MEDIA_FIELDS) {
                    const value = (formData.social_media_links[key] || '').trim();
                    if (!value) continue;
                    let parsedUrl;
                    try {
                        parsedUrl = new URL(value);
                    } catch (error) {
                        throw new Error(`${label} must be a complete URL starting with http:// or https://.`);
                    }
                    if (!['http:', 'https:'].includes(parsedUrl.protocol)) {
                        throw new Error(`${label} must use http:// or https://.`);
                    }
                    normalizedLinks[key] = value;
                }
                dataToSend.append('social_media_links', JSON.stringify(normalizedLinks));
            }
            else if (tabId === 13) { // About company
                const aboutCompany = formData.about_company.trim();
                if (!aboutCompany) {
                    throw new Error('Please write or generate an About Company description.');
                }
                dataToSend.append('about_company', aboutCompany);
            }

            // Append step progression if in wizard mode
            if (isWizardMode) {
                const nextStep = Math.max(registrationStep, targetStep);
                const completedStep = tabId === 11 ? 12 : nextStep;
                dataToSend.append('last_registration_step', completedStep.toString());
                if (tabId === 11) {
                    dataToSend.append('is_verified', '1'); // Auto-activate once all steps completed!
                }
            }

            // Call Backend PATCH API
            dataToSend.append('userId', vendor.id);
            const response = await axios.post(
                `${API_BASE_URL}/vendors/update-details`,
                dataToSend,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            if (response.data && response.data.user) {
                const updatedUser = response.data.user;
                updateVendor(updatedUser);

                if (isWizardMode) {
                    if (tabId === 11) {
                        setNotification({ message: 'Profile Setup Completed! Redirecting...', type: 'success' });
                        setTimeout(() => navigate('/admin/dashboard'), 2500);
                    } else if (tabId === 5) {
                        setNotification({ message: 'KYC Verification Completed! Loading Profile Setup...', type: 'success' });
                        setTimeout(() => navigate('/admin/profile-setup'), 2000);
                    } else {
                        setNotification({ message: 'Step saved successfully!', type: 'success' });
                        // Determine next active tab dynamically from displayedTabs
                        const nextTabObj = displayedTabs.find(t => t.id > tabId);
                        if (nextTabObj) {
                            setActiveTab(nextTabObj.id);
                        } else {
                            setActiveTab(prev => prev + 1);
                        }
                    }
                } else {
                    setNotification({ message: 'Changes saved successfully!', type: 'success' });
                    // Continue through the newly added profile sections in order.
                    if (tabId === 11) {
                        setActiveTab(12);
                    } else if (tabId === 12) {
                        setActiveTab(13);
                    }
                }
            }
        } catch (error) {
            console.error("KYC saving error:", error);
            setNotification({
                message: error.message || error.response?.data?.message || 'Error occurred while saving details.',
                type: 'danger'
            });
        } finally {
            setIsLoading(false);
        }
    };

    // Tab Navigation rules
    const handleTabClick = (targetTabId) => {
        if (!isWizardMode) {
            setActiveTab(targetTabId);
            return;
        }

        // Lock future tabs in Wizard Mode
        const maxUnlockedTab = registrationStep <= 2 ? 3 : registrationStep;
        if (targetTabId > maxUnlockedTab) {
            setNotification({ message: 'Please complete the current step first before moving forward.', type: 'danger' });
            return;
        }

        setActiveTab(targetTabId);
    };

    // Helper: Render Tab Completed Checklist Checkmarks
    const isTabCompleted = (tabId) => {
        if (!isWizardMode) return true;
        return registrationStep > tabId;
    };

    return (
        <>
            <SEO title="KYC & Business Verification | Vendor Dashboard" />
            <style>{`
                .kyc-page {
                    --primary: #0bc184;
                    --primary-hover: #09a671;
                    --success: #0bc184;
                    --success-bg: #e6f9f3;
                    --border-color: #cbd5e1;
                    --text-dark: #1f2937;
                    --text-muted: #6b7280;
                    --bg-color: #f8fafc;
                    --surface-color: #ffffff;
                    --subtle-surface: #f8fafc;
                    --field-bg: #ffffff;
                    --field-disabled-bg: #f1f5f9;
                    --placeholder-color: #94a3b8;
                    --completed-text: #066e4b;
                    --hover-bg: #fcfcff;
                    --active-bg: #e6f9f3;
                    background-color: var(--bg-color);
                    min-height: 80vh;
                    max-width: 1050px;
                    margin: 0 auto 30px auto;
                }

                html[data-bs-theme="dark"] .kyc-page,
                html[data-layout-mode="dark"] .kyc-page {
                    --border-color: #3b4556;
                    --text-dark: #f1f5f9;
                    --text-muted: #b6c2d2;
                    --bg-color: #1a1d21;
                    --surface-color: #212529;
                    --subtle-surface: #272b30;
                    --field-bg: #2a2f35;
                    --field-disabled-bg: #24292f;
                    --placeholder-color: #7f8ca0;
                    --completed-text: #80e2bf;
                    --hover-bg: #252a33;
                    --active-bg: rgba(11, 193, 132, 0.14);
                    --success-bg: rgba(11, 193, 132, 0.14);
                    max-width: 1050px;
                    margin: 0 auto 30px auto;
                }

                .wizard-container {
                    background: var(--surface-color);
                    width: 100%;
                    margin: 0 0 30px;
                    border-radius: 12px;
                    box-shadow: 0 4px 20px rgba(0,0,0,0.05);
                    border: 1px solid var(--border-color);
                    overflow: hidden;
                }

                .wizard-title {
                    padding: 20px 30px;
                    border-bottom: 1px solid var(--border-color);
                    font-size: 1.35rem;
                    font-weight: 700;
                    margin: 0;
                    background-color: var(--surface-color);
                    color: var(--text-dark);
                }

                .wizard-layout {
                    display: flex;
                    flex-direction: row;
                    min-height: 0;
                }

                /* Left Sidebar Tab Navigation */
                .wizard-nav {
                    width: 32%;
                    background-color: var(--surface-color);
                    border-right: 1px solid var(--border-color);
                    padding: 25px 15px;
                    display: flex;
                    flex-direction: column;
                    gap: 12px;
                    box-sizing: border-box;
                }

                .nav-step {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    padding: 12px 16px;
                    border: 1.5px solid var(--border-color);
                    border-radius: 8px;
                    background: var(--surface-color);
                    cursor: pointer;
                    transition: all 0.2s ease;
                    text-align: left;
                    font-size: 0.9rem;
                    font-weight: 600;
                    color: var(--text-dark);
                    width: 100%;
                    box-sizing: border-box;
                }

                .nav-step:hover {
                    border-color: var(--primary);
                    background: var(--hover-bg);
                }

                .nav-step.active {
                    border-color: var(--primary);
                    background: var(--active-bg);
                    color: var(--primary);
                }

                .nav-step.completed {
                    border-color: var(--success);
                    background: var(--success-bg);
                    color: var(--completed-text);
                }

                /* Tab Icon Styling */
                .icon-circle {
                    width: 30px;
                    height: 30px;
                    border-radius: 50%;
                    border: 1.5px solid var(--text-muted);
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    flex-shrink: 0;
                    background: var(--subtle-surface);
                    transition: all 0.2s ease;
                }

                .icon-circle svg {
                    width: 15px;
                    height: 15px;
                    fill: none;
                    stroke: var(--text-muted);
                    stroke-width: 2;
                    transition: all 0.2s ease;
                }

                .active .icon-circle {
                    border-color: var(--primary);
                    background: var(--primary);
                }
                .active .icon-circle svg {
                    stroke: white;
                    fill: white;
                }

                .completed .icon-circle {
                    border-color: var(--success);
                    background: var(--success);
                }
                .completed .icon-circle svg {
                    stroke: white;
                    fill: white;
                }

                /* Right content container */
                .wizard-content {
                    width: 68%;
                    padding: 35px;
                    background: var(--surface-color);
                    box-sizing: border-box;
                }

                .tab-panel {
                    display: none;
                }
                .tab-panel.active {
                    display: block;
                }

                .tab-panel h3 {
                    font-size: 1.45rem;
                    font-weight: 700;
                    color: var(--text-dark);
                    margin-top: 0;
                    margin-bottom: 8px;
                }
                .tab-panel p.sub-text {
                    color: var(--text-muted);
                    font-size: 0.92rem;
                    margin-bottom: 24px;
                }

                .form-group {
                    margin-bottom: 20px;
                    text-align: left;
                }

                .form-row {
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    gap: 15px;
                }

                label {
                    display: block;
                    font-weight: 600;
                    margin-bottom: 8px;
                    font-size: 0.85rem;
                    text-transform: uppercase;
                    letter-spacing: 0.05em;
                    color: var(--text-muted);
                }

                input[type="text"], input[type="email"], input[type="password"], input[type="tel"], select, textarea {
                    width: 100%;
                    padding: 12px;
                    border: 1px solid var(--border-color);
                    border-radius: 8px;
                    box-sizing: border-box;
                    font-size: 0.95rem;
                    color: var(--text-dark);
                    background-color: var(--field-bg);
                }

                input::placeholder, textarea::placeholder {
                    color: var(--placeholder-color);
                    opacity: 1;
                }

                input:disabled, select:disabled, textarea:disabled {
                    background-color: var(--field-disabled-bg);
                    color: var(--text-muted);
                    opacity: 1;
                }

                input:focus, select:focus, textarea:focus {
                    outline: none;
                    border-color: var(--primary);
                    box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.15);
                }

                .social-link-input {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                }
                .social-link-icon {
                    align-items: center;
                    background: var(--subtle-surface);
                    border: 1px solid var(--border-color);
                    border-radius: 8px;
                    color: var(--primary);
                    display: inline-flex;
                    flex: 0 0 46px;
                    font-size: 1.3rem;
                    height: 46px;
                    justify-content: center;
                }
                .social-link-input input {
                    flex: 1;
                    min-width: 0;
                }

                .radio-group {
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    gap: 15px;
                    margin-bottom: 20px;
                }

                .radio-label {
                    border: 1.5px solid var(--border-color);
                    padding: 12px 16px;
                    border-radius: 8px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    font-weight: 600;
                    background: var(--subtle-surface);
                    font-size: 0.9rem;
                    color: var(--text-dark);
                }
                .radio-label:hover {
                    border-color: var(--primary);
                }
                .radio-label input[type="radio"] {
                    width: auto;
                    margin: 0;
                }

                /* Buttons */
                .kyc-page .btn {
                    background: var(--primary);
                    color: white;
                    border: none;
                    padding: 12px 24px;
                    font-size: 0.95rem;
                    font-weight: 600;
                    border-radius: 8px;
                    cursor: pointer;
                    transition: background 0.2s;
                }
                .kyc-page .btn:hover { background: var(--primary-hover); }

                .kyc-page .btn:disabled {
                    background: #94a3b8;
                    cursor: not-allowed;
                }

                .kyc-page .btn-secondary {
                    background: #64748b;
                    color: white;
                }
                .kyc-page .btn-secondary:hover { background: #475569; }

                .kyc-page .btn-success {
                    background: var(--success);
                }
                .kyc-page .btn-success:hover { background: #09a671; }

                /* Fetched items display box */
                .fetched-data-box {
                    background: var(--subtle-surface);
                    border: 1.5px dashed var(--border-color);
                    border-radius: 10px;
                    padding: 20px;
                    margin-top: 20px;
                    margin-bottom: 20px;
                    text-align: left;
                }
                .data-grid {
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    gap: 15px;
                    font-size: 0.9rem;
                    margin-bottom: 15px;
                }
                .data-item span {
                    display: block;
                    color: var(--text-muted);
                    font-size: 0.78rem;
                    font-weight: 600;
                    text-transform: uppercase;
                    letter-spacing: 0.05em;
                }
                .data-item strong {
                    color: var(--text-dark);
                    font-size: 0.95rem;
                }

                /* File uploads */
                .upload-preview-container {
                    display: flex;
                    flex-direction: column;
                    gap: 20px;
                    margin-top: 20px;
                    margin-bottom: 25px;
                }
                .preview-box {
                    border: 1px solid var(--border-color);
                    border-radius: 8px;
                    padding: 15px;
                    background: var(--subtle-surface);
                    text-align: center;
                    box-sizing: border-box;
                    width: 100%;
                }
                .preview-title {
                    font-size: 0.8rem;
                    color: var(--text-muted);
                    margin-bottom: 10px;
                    font-weight: 700;
                    text-transform: uppercase;
                    text-align: left;
                }
                .img-preview {
                    max-width: 100%;
                    max-height: 180px;
                    object-fit: contain;
                    border-radius: 6px;
                    margin: 0 auto;
                    display: block;
                    border: 1px solid #cbd5e1;
                    background: var(--surface-color);
                }
                .no-image-placeholder {
                    height: 110px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #94a3b8;
                    font-size: 0.85rem;
                    border: 2px dashed #cbd5e1;
                    border-radius: 6px;
                    background: var(--surface-color);
                }

                .categories-grid {
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    gap: 12px;
                    margin-bottom: 25px;
                }
                .category-label {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    font-weight: 500;
                    font-size: 0.95rem;
                    cursor: pointer;
                }
                .category-label input {
                    width: auto;
                    height: 18px;
                    width: 18px;
                }

                /* Wizard header notification */
                .wizard-header-alert {
                    background-color: #fef3c7;
                    color: #b45309;
                    padding: 16px 24px;
                    border-radius: 12px;
                    margin-bottom: 24px;
                    border: 1px solid #fde68a;
                    text-align: left;
                }
                .wizard-header-alert h4 {
                    font-weight: 700;
                    margin-top: 0;
                    margin-bottom: 4px;
                    font-size: 1.05rem;
                }
                .wizard-header-alert p {
                    margin: 0;
                    font-size: 0.88rem;
                    color: #92400e;
                }

                /* Alert boxes */
                .alert {
                    padding: 14px 20px;
                    border-radius: 8px;
                    margin-bottom: 24px;
                    font-size: 0.92rem;
                    font-weight: 500;
                    text-align: left;
                }
                .alert-success {
                    background-color: #dcfce7;
                    color: #15803d;
                    border: 1px solid #bbf7d0;
                }
                .alert-danger {
                    background-color: #fee2e2;
                    color: #b91c1c;
                    border: 1px solid #fca5a5;
                }

                /* Responsive design */
                @media (max-width: 768px) {
                    .wizard-layout {
                        flex-direction: column;
                    }
                    .wizard-nav {
                        width: 100%;
                        border-right: none;
                        border-bottom: 1px solid var(--border-color);
                        padding: 15px;
                        flex-direction: row;
                        overflow-x: auto;
                        white-space: nowrap;
                    }
                    .nav-step {
                        padding: 8px 12px;
                        font-size: 0.8rem;
                        display: inline-flex;
                        width: auto;
                        gap: 6px;
                    }
                    .icon-circle {
                        width: 24px;
                        height: 24px;
                    }
                    .icon-circle svg {
                        width: 12px;
                        height: 12px;
                    }
                    .wizard-content {
                        width: 100%;
                        padding: 20px;
                    }
                    .form-row, .radio-group, .categories-grid {
                        grid-template-columns: 1fr;
                        gap: 5px;
                    }
                }
            `}</style>

            {(() => {
                const currentTab = displayedTabs.find(t => t.id === activeTab);
                const currentTabIndex = displayedTabs.indexOf(currentTab) + 1;
                const totalTabsCount = displayedTabs.length;

                return (
                    <div className="kyc-page">
                        <div className="row">
                            <div className="col-12">
                                {isWizardMode && (
                                    <div className="wizard-header-alert shadow-sm">
                                        <h4>{!isKYC ? 'Profile Setup Pending' : 'KYC Verification Pending'}</h4>
                                        <p>Welcome! Please complete the steps below to customize your vendor profile and settings.</p>
                                    </div>
                                )}

                                {notification.message && (
                                    <div className={`alert alert-${notification.type === 'success' ? 'success' : 'danger'} shadow-sm`} role="alert">
                                        {notification.message}
                                    </div>
                                )}

                                <div className="wizard-container shadow-sm">
                                    <div className="wizard-title text-start d-flex justify-content-between align-items-center">
                                        <span>{!isKYC ? 'Profile Setup' : 'KYC Verification'}</span>
                                        <span className="badge text-white px-3 py-2" style={{ backgroundColor: isWizardMode ? 'var(--primary)' : 'var(--success)', fontSize: '0.8rem', borderRadius: '20px' }}>
                                            {isWizardMode ? `Step ${currentTabIndex} of ${totalTabsCount}` : 'Verified Vendor'}
                                        </span>
                                    </div>

                                    <div className="wizard-layout">
                                        {/* Left Side: Tabs List */}
                                        <div className="wizard-nav">
                                            {displayedTabs.map(tab => {
                                                const active = tab.id === activeTab;
                                                const completed = isTabCompleted(tab.id);
                                                const isSkippedBusiness = tab.key === 'business' && formData.gst_number === 'N/A';

                                                let stepClass = 'nav-step';
                                                if (active) stepClass += ' active';
                                                else if (isSkippedBusiness) stepClass += ' skipped';
                                                else if (completed) stepClass += ' completed';

                                                return (
                                                    <button
                                                        key={tab.id}
                                                        className={stepClass}
                                                        onClick={() => handleTabClick(tab.id)}
                                                    >
                                                        <span className="icon-circle">
                                                            {isSkippedBusiness ? KYC_ICONS.alert : completed ? KYC_ICONS.greenTick : tab.icon}
                                                        </span>
                                                        <span>{tab.label}</span>
                                                    </button>
                                                );
                                            })}
                                        </div>

                                        {/* Right Side: Active Tab Content */}
                                        <div className="wizard-content">

                                            {/* TAB 6: ACCOUNT INFO */}
                                            <div className={`tab-panel ${activeTab === 6 ? 'active' : ''}`}>
                                                <h3>Account Information</h3>
                                                <p className="sub-text">Define your login email and set a secure password for your portal access.</p>
                                                <div className="form-group">
                                                    <label htmlFor="name">Name</label>
                                                    <input
                                                        type="text"
                                                        id="name"
                                                        name="name"
                                                        placeholder="Enter Your Name"
                                                        value={formData.name}
                                                        onChange={handleInputChange}
                                                        disabled={isLoading}
                                                        required
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="email">Email Address</label>
                                                    <input
                                                        type="email"
                                                        id="email"
                                                        name="email"
                                                        placeholder="e.g. travel@example.com"
                                                        value={formData.email}
                                                        onChange={handleInputChange}
                                                        disabled={isLoading}
                                                        required
                                                    />
                                                </div>

                                                {isWizardMode && (
                                                    <div className="form-row">
                                                        <div className="form-group">
                                                            <label htmlFor="password">Password</label>
                                                            <input
                                                                type="password"
                                                                id="password"
                                                                name="password"
                                                                placeholder="Password"
                                                                value={formData.password}
                                                                onChange={handleInputChange}
                                                                disabled={isLoading}
                                                                required
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label htmlFor="confirmPassword">Confirm Password</label>
                                                            <input
                                                                type="password"
                                                                id="confirmPassword"
                                                                name="confirmPassword"
                                                                placeholder="Confirm Password"
                                                                value={formData.confirmPassword}
                                                                onChange={handleInputChange}
                                                                disabled={isLoading}
                                                                required
                                                            />
                                                        </div>
                                                    </div>
                                                )}

                                                <button
                                                    type="button"
                                                    className="btn mt-3"
                                                    onClick={() => handleSaveTabDetails(6)}
                                                    disabled={isLoading}
                                                >
                                                    {isLoading ? 'Saving...' : (isWizardMode ? 'Save & Continue' : 'Save Changes')}
                                                </button>
                                            </div>

                                            {/* TAB 3: BUSINESS VERIFICATION */}
                                            <div className={`tab-panel ${activeTab === 3 ? 'active' : ''}`}>
                                                <h3>Business Verification</h3>
                                                <p className="sub-text">Enter your GSTIN number to verify your business registry instantly with the GST portal.</p>

                                                {/* Show saved GST data if exists and not editing */}
                                                {vendor?.gst_number && vendor.gst_number !== 'N/A' && !isEditingBusiness && !gstDataBoxVisible ? (
                                                    <>
                                                        <div className="fetched-data-box" style={{ borderColor: 'var(--success)' }}>
                                                            <h4 className="fw-bold mb-3" style={{ color: 'var(--success)', fontSize: '1.1rem' }}>✓ Business Verified</h4>
                                                            <div className="data-grid">
                                                                <div className="data-item"><span>Company Name</span><strong>{vendor.company_name || 'N/A'}</strong></div>
                                                                <div className="data-item"><span>GSTIN No.</span><strong>{vendor.gst_number}</strong></div>
                                                                <div className="data-item"><span>Registered Address</span><strong>{vendor.company_address || 'N/A'}</strong></div>
                                                                <div className="data-item"><span>City</span><strong>{vendor.company_city || 'N/A'}</strong></div>
                                                                <div className="data-item"><span>Pin Code</span><strong>{vendor.company_pincode || 'N/A'}</strong></div>
                                                                <div className="data-item"><span>State</span><strong>{vendor.company_state || 'N/A'}</strong></div>
                                                            </div>
                                                            {!isWizardMode && (
                                                                <button type="button" className="btn btn-outline-primary mt-2" onClick={() => {
                                                                    setIsEditingBusiness(true);
                                                                    setFormData(prev => ({ ...prev, gst_number: '' }));
                                                                    setGstDataBoxVisible(false);
                                                                    setGstDetails(null);
                                                                }} disabled={isLoading}>
                                                                    Edit GST Number
                                                                </button>
                                                            )}
                                                        </div>
                                                    </>
                                                ) : (
                                                    <>
                                                        <div className="form-group">
                                                            <label htmlFor="gst_number">GSTIN / GST Number</label>
                                                            <input
                                                                type="text"
                                                                id="gst_number"
                                                                name="gst_number"
                                                                placeholder="e.g. 22AAAAA1111A1Z1"
                                                                value={formData.gst_number}
                                                                onChange={handleInputChange}
                                                                disabled={isLoading}
                                                            />

                                                            <div style={{ marginTop: '15px', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                                                                <button type="button" className="btn" onClick={handleFetchGstDetails} disabled={isLoading}>
                                                                    Fetch GST Details
                                                                </button>
                                                                {!isEditingBusiness && (
                                                                    <button type="button" className="btn btn-secondary" onClick={handleSkipGst} disabled={isLoading}>
                                                                        GST Not Available / Skip
                                                                    </button>
                                                                )}
                                                                {isEditingBusiness && (
                                                                    <button type="button" className="btn btn-secondary" onClick={() => {
                                                                        setIsEditingBusiness(false);
                                                                        setFormData(prev => ({ ...prev, gst_number: vendor.gst_number || '' }));
                                                                    }} disabled={isLoading}>
                                                                        Cancel
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </div>

                                                        {gstDataBoxVisible && gstDetails && (
                                                            <div className="fetched-data-box">
                                                                <h4 className="fw-bold mb-3" style={{ color: 'var(--primary)', fontSize: '1.1rem' }}>GST Records Found:</h4>
                                                                <div className="data-grid">
                                                                    <div className="data-item"><span>Company Name</span><strong>{gstDetails.compName}</strong></div>
                                                                    <div className="data-item"><span>GSTIN No.</span><strong>{gstDetails.gstNo}</strong></div>
                                                                    <div className="data-item"><span>Registered Address</span><strong>{gstDetails.address}</strong></div>
                                                                    <div className="data-item"><span>City</span><strong>{gstDetails.city}</strong></div>
                                                                    <div className="data-item"><span>Pin Code</span><strong>{gstDetails.pin}</strong></div>
                                                                    <div className="data-item"><span>State</span><strong>{gstDetails.state}</strong></div>
                                                                </div>
                                                                <button type="button" className="btn btn-success mt-2" onClick={() => { handleConfirmGst(); setIsEditingBusiness(false); }} disabled={isLoading}>
                                                                    Confirm & Submit Business Details
                                                                </button>
                                                            </div>
                                                        )}
                                                    </>
                                                )}

                                                {!isWizardMode && !isEditingBusiness && !vendor?.gst_number && (
                                                    <button type="button" className="btn" onClick={() => handleSaveTabDetails(3)} disabled={isLoading}>
                                                        {isLoading ? 'Saving...' : 'Save Changes'}
                                                    </button>
                                                )}
                                            </div>

                                            {/* TAB 4: PERSONAL KYC */}
                                            <div className={`tab-panel ${activeTab === 4 ? 'active' : ''}`}>
                                                <h3>Personal KYC</h3>
                                                <p className="sub-text">Enter Aadhaar linked mobile number to verify profile details via DigiLocker, or upload a manual identification proof.</p>

                                                {/* Show saved Aadhaar data if exists and not editing */}
                                                {vendor?.personal_aadhaar && !isEditingPersonal && digilockerBoxVisible ? (
                                                    <>
                                                        <div className="fetched-data-box" style={{ borderColor: 'var(--success)' }}>
                                                            <h4 className="fw-bold mb-3" style={{ color: 'var(--success)', fontSize: '1.1rem' }}>✓ Personal KYC Verified</h4>
                                                            <div className="data-grid">
                                                                <div className="data-item"><span>Full Name</span><strong>{formData.personal_name}</strong></div>
                                                                <div className="data-item"><span>Date of Birth</span><strong>{formData.personal_dob}</strong></div>
                                                                <div className="data-item"><span>Gender</span><strong>{formData.personal_gender}</strong></div>
                                                                <div className="data-item"><span>Aadhaar Card No.</span><strong>{formData.personal_aadhaar}</strong></div>
                                                            </div>
                                                            {!isWizardMode && (
                                                                <button type="button" className="btn btn-outline-primary mt-2" onClick={() => {
                                                                    setIsEditingPersonal(true);
                                                                    setDigilockerBoxVisible(false);
                                                                    setFormData(prev => ({ ...prev, aadhaar_mobile: '' }));
                                                                }} disabled={isLoading}>
                                                                    Edit Aadhaar (Re-verify)
                                                                </button>
                                                            )}
                                                        </div>

                                                        <button
                                                            type="button"
                                                            className="btn mt-3"
                                                            onClick={() => handleSaveTabDetails(4)}
                                                            disabled={isLoading}
                                                        >
                                                            {isLoading ? 'Saving...' : (isWizardMode ? 'Save & Continue' : 'Save Changes')}
                                                        </button>
                                                    </>
                                                ) : (
                                                    <>
                                                        <div className="form-row">
                                                            <div className="form-group">
                                                                <label htmlFor="aadhaar_mobile">Aadhaar Linked Mobile Number</label>
                                                                <input
                                                                    type="tel"
                                                                    id="aadhaar_mobile"
                                                                    name="aadhaar_mobile"
                                                                    placeholder="Enter 10-digit number"
                                                                    value={formData.aadhaar_mobile}
                                                                    onChange={handleInputChange}
                                                                    disabled={isLoading || digilockerBoxVisible}
                                                                />
                                                                <div style={{ marginTop: '10px', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                                                                    {!digilockerBoxVisible && (
                                                                        <button type="button" className="btn mt-2" onClick={handleDigilockerVerify} disabled={isLoading}>
                                                                            Verify via DigiLocker
                                                                        </button>
                                                                    )}
                                                                    {isEditingPersonal && (
                                                                        <button type="button" className="btn btn-secondary mt-2" onClick={() => {
                                                                            setIsEditingPersonal(false);
                                                                            setDigilockerBoxVisible(true);
                                                                            setFormData(prev => ({
                                                                                ...prev,
                                                                                personal_name: vendor.personal_name || '',
                                                                                personal_dob: vendor.personal_dob || '',
                                                                                personal_gender: vendor.personal_gender || '',
                                                                                personal_aadhaar: vendor.personal_aadhaar || '',
                                                                            }));
                                                                        }} disabled={isLoading}>
                                                                            Cancel
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {digilockerBoxVisible && (
                                                            <div className="fetched-data-box" style={{ borderColor: '#ea580c' }}>
                                                                <h4 className="fw-bold mb-3" style={{ color: '#ea580c', fontSize: '1.1rem' }}>DigiLocker Profile Verified:</h4>
                                                                <div className="data-grid">
                                                                    <div className="data-item"><span>Full Name</span><strong>{formData.personal_name}</strong></div>
                                                                    <div className="data-item"><span>Date of Birth</span><strong>{formData.personal_dob}</strong></div>
                                                                    <div className="data-item"><span>Gender</span><strong>{formData.personal_gender}</strong></div>
                                                                    <div className="data-item"><span>Aadhaar Card No.</span><strong>{formData.personal_aadhaar}</strong></div>
                                                                </div>
                                                            </div>
                                                        )}

                                                        <button
                                                            type="button"
                                                            className="btn mt-3"
                                                            onClick={() => { handleSaveTabDetails(4); setIsEditingPersonal(false); }}
                                                            disabled={isLoading}
                                                        >
                                                            {isLoading ? 'Saving...' : (isWizardMode ? 'Save & Continue' : 'Save Changes')}
                                                        </button>
                                                    </>
                                                )}
                                            </div>

                                            {/* TAB 5: OPERATIONAL ADDRESS */}
                                            <div className={`tab-panel ${activeTab === 5 ? 'active' : ''}`}>
                                                <h3>Operational Address</h3>
                                                <p className="sub-text">Provide your current operational address or set it as your registered company address.</p>

                                                <div className="radio-group">
                                                    <label className="radio-label">
                                                        <input
                                                            type="radio"
                                                            name="addressOption"
                                                            value="same"
                                                            checked={addressOption === 'same'}
                                                            onChange={() => handleAddressOptionChange('same')}
                                                            disabled={isLoading}
                                                        />
                                                        Same as Registered Address
                                                    </label>
                                                    <label className="radio-label">
                                                        <input
                                                            type="radio"
                                                            name="addressOption"
                                                            value="new"
                                                            checked={addressOption === 'new'}
                                                            onChange={() => handleAddressOptionChange('new')}
                                                            disabled={isLoading}
                                                        />
                                                        New Operational Address
                                                    </label>
                                                </div>

                                                <div className="form-group">
                                                    <label htmlFor="operational_address">Office / Shop Address Line</label>
                                                    <textarea
                                                        id="operational_address"
                                                        name="operational_address"
                                                        rows="2"
                                                        placeholder="Enter operational office address"
                                                        value={formData.operational_address}
                                                        onChange={handleInputChange}
                                                        disabled={isLoading || addressOption === 'same'}
                                                        required
                                                    ></textarea>
                                                </div>

                                                <div className="form-group">
                                                    <label htmlFor="operational_landmark">Landmark</label>
                                                    <input
                                                        type="text"
                                                        id="operational_landmark"
                                                        name="operational_landmark"
                                                        placeholder="Ex: Opposite Natraj Market"
                                                        value={formData.operational_landmark}
                                                        onChange={handleInputChange}
                                                        disabled={isLoading || addressOption === 'same'}
                                                    />
                                                </div>

                                                <div className="form-row">
                                                    <div className="form-group">
                                                        <label htmlFor="operational_city">City</label>
                                                        <input
                                                            type="text"
                                                            id="operational_city"
                                                            name="operational_city"
                                                            placeholder="City"
                                                            value={formData.operational_city}
                                                            onChange={handleInputChange}
                                                            disabled={isLoading || addressOption === 'same'}
                                                            required
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="operational_pincode">Pin Code</label>
                                                        <input
                                                            type="text"
                                                            id="operational_pincode"
                                                            name="operational_pincode"
                                                            placeholder="Pincode"
                                                            value={formData.operational_pincode}
                                                            onChange={handleInputChange}
                                                            disabled={isLoading || addressOption === 'same'}
                                                            required
                                                        />
                                                    </div>
                                                </div>

                                                <div className="form-group">
                                                    <label htmlFor="operational_state">State</label>
                                                    <input
                                                        type="text"
                                                        id="operational_state"
                                                        name="operational_state"
                                                        placeholder="State"
                                                        value={formData.operational_state}
                                                        onChange={handleInputChange}
                                                        disabled={isLoading || addressOption === 'same'}
                                                        required
                                                    />
                                                </div>

                                                <button
                                                    type="button"
                                                    className="btn mt-3"
                                                    onClick={() => handleSaveTabDetails(5)}
                                                    disabled={isLoading}
                                                >
                                                    {isLoading ? 'Saving...' : (isWizardMode ? 'Save & Continue' : 'Save Changes')}
                                                </button>
                                            </div>

                                            {/* TAB 7: LOGO & BANNER */}
                                            <div className={`tab-panel ${activeTab === 7 ? 'active' : ''}`}>
                                                <h3>Logo and Banner</h3>
                                                <p className="sub-text">Upload your business logo and marketing shop banner images to showcase your business on public listings.</p>

                                                <div className="form-row">
                                                    <div className="form-group">
                                                        <label htmlFor="companyLogo">Upload Brand Logo</label>
                                                        <input
                                                            type="file"
                                                            id="companyLogo"
                                                            name="companyLogo"
                                                            onChange={handleFileChange}
                                                            accept="image/*"
                                                            disabled={isLoading}
                                                        />
                                                    </div>

                                                    <div className="form-group">
                                                        <label htmlFor="companyBanner">Upload Shop Banner</label>
                                                        <input
                                                            type="file"
                                                            id="companyBanner"
                                                            name="companyBanner"
                                                            onChange={handleFileChange}
                                                            accept="image/*"
                                                            disabled={isLoading}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="upload-preview-container">
                                                    <div className="preview-box">
                                                        <div className="preview-title">Logo Preview</div>
                                                        {filePreviews.companyLogo ? (
                                                            <img src={filePreviews.companyLogo} className="img-preview" alt="Logo Preview" />
                                                        ) : (
                                                            <div className="no-image-placeholder">No logo chosen</div>
                                                        )}
                                                    </div>

                                                    <div className="preview-box">
                                                        <div className="preview-title">Banner Preview</div>
                                                        {filePreviews.companyBanner ? (
                                                            <img src={filePreviews.companyBanner} className="img-preview" alt="Banner Preview" style={{ maxHeight: '140px', width: '100%', objectFit: 'cover' }} />
                                                        ) : (
                                                            <div className="no-image-placeholder">No banner chosen</div>
                                                        )}
                                                    </div>
                                                </div>

                                                <button
                                                    type="button"
                                                    className="btn mt-3"
                                                    onClick={() => handleSaveTabDetails(7)}
                                                    disabled={isLoading}
                                                >
                                                    {isLoading ? 'Saving...' : (isWizardMode ? 'Save & Continue' : 'Save Changes')}
                                                </button>
                                            </div>

                                            {/* TAB 9: COMPANY INFO */}
                                            <div className={`tab-panel ${activeTab === 9 ? 'active' : ''}`}>
                                                <h3>Company Information</h3>
                                                <p className="sub-text">Check your basic contact parameters. Operational communication will take place on these channels.</p>

                                                <div className="form-group">
                                                    <label htmlFor="company_name">Company Name</label>
                                                    <input
                                                        type="text"
                                                        id="company_name"
                                                        name="company_name"
                                                        placeholder="Registered Company Name"
                                                        value={formData.company_name}
                                                        onChange={handleInputChange}
                                                        disabled={isLoading}
                                                        required
                                                    />
                                                </div>

                                                <div className="form-row">
                                                    <div className="form-group">
                                                        <label htmlFor="phone">Contact Number (Registered Phone)</label>
                                                        <div style={{ display: 'flex', alignItems: 'center', border: '1px solid var(--border-color)', borderRadius: '8px', background: '#f8fafc', overflow: 'hidden' }}>
                                                            <span style={{ padding: '14px', background: '#e2e8f0', color: '#64748b', borderRight: '1px solid var(--border-color)', fontWeight: 600 }}>+91</span>
                                                            <input
                                                                type="text"
                                                                id="phone"
                                                                name="phone"
                                                                value={(() => {
                                                                    const p = String(formData.phone || '').replace(/^\+/, '');
                                                                    return p.length >= 12 && p.startsWith('91') ? p.substring(2) : p;
                                                                })()}
                                                                disabled
                                                                style={{ border: 'none', padding: '14px', width: '100%', outline: 'none', background: 'transparent' }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="whatsapp_no">WhatsApp Number</label>
                                                        <div style={{ display: 'flex', alignItems: 'center', border: '1px solid var(--border-color)', borderRadius: '8px', background: '#fff', overflow: 'hidden' }}>
                                                            <span style={{ padding: '14px', background: '#f8fafc', borderRight: '1px solid var(--border-color)', fontWeight: 600, color: 'var(--text-dark)' }}>+91</span>
                                                            <input
                                                                type="text"
                                                                id="whatsapp_no"
                                                                name="whatsapp_no"
                                                                placeholder="Enter 10-digit number"
                                                                value={(() => {
                                                                    const p = String(formData.whatsapp_no || '').replace(/^\+/, '');
                                                                    return p.length >= 12 && p.startsWith('91') ? p.substring(2) : p;
                                                                })()}
                                                                onChange={(e) => {
                                                                    const val = e.target.value.replace(/\D/g, '').slice(0, 10);
                                                                    handleInputChange({ target: { name: 'whatsapp_no', value: '91' + val } });
                                                                }}
                                                                disabled={isLoading}
                                                                style={{ border: 'none', padding: '14px', width: '100%', outline: 'none' }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="form-group">
                                                    <label>Account Email</label>
                                                    <input
                                                        type="text"
                                                        value={formData.email || 'Email Pending'}
                                                        disabled
                                                    />
                                                </div>

                                                <button
                                                    type="button"
                                                    className="btn mt-3"
                                                    onClick={() => handleSaveTabDetails(9)}
                                                    disabled={isLoading}
                                                >
                                                    {isLoading ? 'Saving...' : (isWizardMode ? 'Save & Continue' : 'Save Changes')}
                                                </button>
                                            </div>

                                            {/* TAB 8: CATEGORIES */}
                                            <div className={`tab-panel ${activeTab === 8 ? 'active' : ''}`}>
                                                <h3>Business Categories</h3>
                                                <p className="sub-text">Select one or more categories that represent your core travel and listing services.</p>

                                                <div className="categories-grid">
                                                    {CATEGORIES_LIST.map(cat => (
                                                        <label key={cat} className="category-label text-start">
                                                            <input
                                                                type="checkbox"
                                                                name="business_categories"
                                                                value={cat}
                                                                checked={formData.business_categories.includes(cat)}
                                                                onChange={handleCategoryCheckboxChange}
                                                                disabled={isLoading}
                                                            />
                                                            {cat === 'Cabs' ? 'Cab Service' : (cat === 'Hotels' ? 'Hotel Service' : (cat === 'Holidays' ? 'Holiday Packages' : cat))}
                                                        </label>
                                                    ))}
                                                </div>

                                                {formData.business_categories.includes('Other') && (
                                                    <div className="form-group">
                                                        <label htmlFor="other_category">Specify Other Service</label>
                                                        <input
                                                            type="text"
                                                            id="other_category"
                                                            name="other_category"
                                                            placeholder="e.g. Flight Booking, Tour Guide"
                                                            value={formData.other_category}
                                                            onChange={handleInputChange}
                                                            disabled={isLoading}
                                                            required
                                                        />
                                                    </div>
                                                )}

                                                <button
                                                    type="button"
                                                    className="btn mt-3"
                                                    onClick={() => handleSaveTabDetails(8)}
                                                    disabled={isLoading}
                                                >
                                                    {isLoading ? 'Saving...' : (isWizardMode ? 'Save & Continue' : 'Save Changes')}
                                                </button>
                                            </div>

                                            {/* TAB 10: WHATSAPP NUMBERS */}
                                            <div className={`tab-panel ${activeTab === 10 ? 'active' : ''}`}>
                                                <h3>WhatsApp Numbers</h3>
                                                <p className="sub-text">Add up to 3 WhatsApp numbers to receive notifications. The first one is your default number.</p>

                                                {formData.notification_whatsapps.map((num, index) => (
                                                    <div className="form-group" key={index}>
                                                        <label htmlFor={`whatsapp_no_${index}`}>
                                                            WhatsApp Number {index + 1} {index === 0 && "(Default)"}
                                                        </label>
                                                        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                                            <div style={{ display: 'flex', alignItems: 'center', border: '1px solid var(--border-color)', borderRadius: '8px', background: index === 0 ? '#f8fafc' : '#fff', overflow: 'hidden', flex: 1 }}>
                                                                <span style={{ padding: '14px', background: index === 0 ? '#e2e8f0' : '#f8fafc', color: index === 0 ? '#64748b' : 'var(--text-dark)', borderRight: '1px solid var(--border-color)', fontWeight: 600 }}>+91</span>
                                                                <input
                                                                    type="text"
                                                                    id={`whatsapp_no_${index}`}
                                                                    name={`whatsapp_no_${index}`}
                                                                    placeholder="Enter 10-digit number"
                                                                    value={(() => {
                                                                        const p = String(num || '').replace(/^\+/, '');
                                                                        return p.length >= 12 && p.startsWith('91') ? p.substring(2) : p;
                                                                    })()}
                                                                    onChange={(e) => {
                                                                        const val = e.target.value.replace(/\D/g, '').slice(0, 10);
                                                                        handleNotificationWhatsappChange(index, '91' + val);
                                                                    }}
                                                                    disabled={isLoading || index === 0}
                                                                    required={index === 0}
                                                                    style={{ border: 'none', padding: '14px', width: '100%', outline: 'none', background: 'transparent' }}
                                                                />
                                                            </div>
                                                            {index > 0 && (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-secondary"
                                                                    onClick={() => removeNotificationWhatsappField(index)}
                                                                    disabled={isLoading}
                                                                >
                                                                    Remove
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                ))}

                                                {formData.notification_whatsapps.length < 3 && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary mb-3"
                                                        onClick={addNotificationWhatsappField}
                                                        disabled={isLoading}
                                                    >
                                                        + Add WhatsApp Number
                                                    </button>
                                                )}

                                                <div>
                                                    <button
                                                        type="button"
                                                        className="btn mt-3"
                                                        onClick={() => handleSaveTabDetails(10)}
                                                        disabled={isLoading}
                                                    >
                                                        {isLoading ? 'Saving...' : (isWizardMode ? 'Save & Continue' : 'Save Changes')}
                                                    </button>
                                                </div>
                                            </div>

                                            {/* TAB 11: EMAIL IDS */}
                                            <div className={`tab-panel ${activeTab === 11 ? 'active' : ''}`}>
                                                <h3>Email Addresses</h3>
                                                <p className="sub-text">Add up to 3 email addresses to receive email notifications. The first one is your default email.</p>

                                                {formData.notification_emails.map((email, index) => (
                                                    <div className="form-group" key={index}>
                                                        <label htmlFor={`email_id_${index}`}>
                                                            Email Address {index + 1} {index === 0 && "(Default)"}
                                                        </label>
                                                        <div style={{ display: 'flex', gap: '10px' }}>
                                                            <input
                                                                type="email"
                                                                id={`email_id_${index}`}
                                                                name={`email_id_${index}`}
                                                                placeholder="e.g. travel@example.com"
                                                                value={email}
                                                                onChange={(e) => handleNotificationEmailChange(index, e.target.value)}
                                                                disabled={isLoading || index === 0}
                                                                required={index === 0}
                                                            />
                                                            {index > 0 && (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-secondary"
                                                                    onClick={() => removeNotificationEmailField(index)}
                                                                    disabled={isLoading}
                                                                >
                                                                    Remove
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                ))}

                                                {formData.notification_emails.length < 3 && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary mb-3"
                                                        onClick={addNotificationEmailField}
                                                        disabled={isLoading}
                                                    >
                                                        + Add Email Address
                                                    </button>
                                                )}

                                                <div>
                                                    <button
                                                        type="button"
                                                        className="btn btn-success mt-3"
                                                        onClick={() => handleSaveTabDetails(11)}
                                                        disabled={isLoading}
                                                    >
                                                        {isLoading ? 'Submitting...' : (isWizardMode ? 'Final Submit & Activate Account' : 'Save Changes')}
                                                    </button>
                                                </div>
                                            </div>

                                            {/* TAB 12: SOCIAL LINKS */}
                                            <div className={`tab-panel ${activeTab === 12 ? 'active' : ''}`}>
                                                <h3>Social Links</h3>
                                                <p className="sub-text">Add your company's social profiles. These links are displayed on your public vendor page.</p>

                                                <div className="form-row">
                                                    {SOCIAL_MEDIA_FIELDS.map(([key, label, icon]) => (
                                                        <div className="form-group" key={key}>
                                                            <label htmlFor={`social_${key}`}>{label}</label>
                                                            <div className="social-link-input">
                                                                <span className="social-link-icon" aria-hidden="true">
                                                                    <i className={`bi ${icon}`}></i>
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    id={`social_${key}`}
                                                                    placeholder={`https://${key}.com/...`}
                                                                    value={formData.social_media_links[key] || ''}
                                                                    onChange={(event) => setFormData(prev => ({
                                                                        ...prev,
                                                                        social_media_links: {
                                                                            ...prev.social_media_links,
                                                                            [key]: event.target.value
                                                                        }
                                                                    }))}
                                                                    disabled={isLoading}
                                                                />
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>

                                                <button
                                                    type="button"
                                                    className="btn btn-success mt-3"
                                                    onClick={() => handleSaveTabDetails(12)}
                                                    disabled={isLoading}
                                                >
                                                    {isLoading ? 'Saving...' : 'Save Changes'}
                                                </button>
                                            </div>

                                            {/* TAB 13: ABOUT COMPANY */}
                                            <div className={`tab-panel ${activeTab === 13 ? 'active' : ''}`}>
                                                <h3>About Company</h3>
                                                <p className="sub-text">Write your company profile or generate a draft using your company name, categories, and location.</p>

                                                <div className="form-group">
                                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                                        <label htmlFor="about_company" className="mb-0">Company Description</label>
                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary"
                                                            style={{ padding: '8px 14px', fontSize: '0.82rem' }}
                                                            onClick={handleGenerateAboutCompany}
                                                            disabled={isLoading || isGeneratingAbout}
                                                        >
                                                            {isGeneratingAbout ? 'Generating...' : 'Generate with AI'}
                                                        </button>
                                                    </div>
                                                    <textarea
                                                        id="about_company"
                                                        name="about_company"
                                                        rows={9}
                                                        maxLength={3000}
                                                        placeholder="Describe your company, services, and what customers can expect."
                                                        value={formData.about_company}
                                                        onChange={handleInputChange}
                                                        disabled={isLoading || isGeneratingAbout}
                                                    />
                                                    <small style={{ color: 'var(--text-muted)' }}>
                                                        {formData.about_company.length}/3000 characters. Review AI-generated text before saving.
                                                    </small>
                                                </div>

                                                <button
                                                    type="button"
                                                    className="btn btn-success mt-3"
                                                    onClick={() => handleSaveTabDetails(13)}
                                                    disabled={isLoading || isGeneratingAbout}
                                                >
                                                    {isLoading ? 'Saving...' : 'Save Changes'}
                                                </button>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })()}

            <ImageCropperModal
                show={cropModal.show}
                onHide={() => setCropModal({ ...cropModal, show: false })}
                imageSrc={cropModal.src}
                aspectRatio={cropModal.aspectRatio}
                circularCrop={cropModal.circularCrop}
                onSave={handleCropSave}
            />
        </>
    );
};

export default Kyc;
